/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, ViewChild } from '@angular/core';
import { Environment } from '@cyborg-monorepo/hunter/common';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { FilterService } from '@progress/kendo-angular-grid';
import {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import { BaseCustomFilterComponent } from './base-custom-filter.component';

@Component({ standalone: false, 
  selector: 'multiselect-environment-filter',
  template: `
    <kendo-multiselect
      #multiselect
      [value]="currentFilterValue"
      [data]="data"
      [field]="field"
      (valueChange)="onChange($event)"
      [textField]="textField"
      [valueField]="valueField"
      placeholder="(All)"
    >
    </kendo-multiselect>
  `,
})
export class MultiselectEnvironmentFilterComponent extends BaseCustomFilterComponent {
  public get selectedValue(): any {
    const filter = this.filterByField(this.valueField);
    return filter ? filter.value : null;
  }

  @ViewChild('multiselect', { read: MultiSelectComponent })
  public select: MultiSelectComponent;

  @Input() public filter: CompositeFilterDescriptor;
  @Input() public data: Environment[];
  @Input() public field: string;
  @Input() public textField: string;
  @Input() public valueField: string;

  // Constructor needed for proper filter functioning
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(filterService: FilterService) {
    super(filterService);
  }

  public get currentFilterValue(): any {
    if (this.filter && this.filter.filters) {
      const filter = (this.filter.filters as FilterDescriptor[]).find(
        ({ field }) => {
          return field === this.field;
        },
      );
      const result: any[] = [];
      if (filter && filter.value && filter.value.length && this.data) {
        filter.value.forEach((value) => {
          const item: any[] = this.data.filter((item) => {
            return item.id === value;
          });

          if (item && item[0]) {
            result.push(item[0]);
          }
        });
      }
      return result;
    } else return [];
  }

  public resetDefault(): void {
    this.select.reset();
  }

  public onChange(value: any): void {
    const processedValue = value.map((a) => a.id);

    this.applyFilter(
      value === null || processedValue.length == 0 // value of the default item
        ? this.removeFilter(this.field) // remove the filter
        : this.updateFilter({
            // add a filter for the field with the value
            field: this.field,
            operator: 'eq',
            value: processedValue,
          }),
    ); // update the root filter
  }
}
